import * as Sentry from '@sentry/react';
import React, { memo } from 'react';
import type { ReactNode } from 'react';

import PageError from './PageError';

interface Props {
	children: ReactNode;
}

const ErrorBoundary = memo(function ErrorBoundary({ children }: Props) {
	return (
		<Sentry.ErrorBoundary fallback={<PageError homepageButton reloadButton={false} />}>{children}</Sentry.ErrorBoundary>
	);
});

export default ErrorBoundary;
